import { logError } from "@/shared/logging/errors";

import { config } from "@/app/App";

export class Preloader {
    private $element: JQuery;
    private $fill: JQuery;
    private $label?: JQuery;

    private loadHandlers: Array<Promise<void>>;
    private currentProgressed = 0;
    public done?: Promise<void>;

    constructor($element: JQuery) {
        this.$element = $element;
        this.$fill = this.$element.find("> .logo > .fill");

        if (config.showLoadingLabels) this.$label = $('<div class="label" />').appendTo(this.$element);

        this.loadHandlers = new Array<Promise<void>>();
    }

    public addHandler(handler: Promise<any>, label?: string): Preloader {
        handler["label"] = label;
        this.loadHandlers.push(handler);
        handler
            .then(() => {
                if (this.$label !== undefined && handler["label"] !== undefined) this.$label.html(handler["label"]);

                this.currentProgressed++;
                this.updateProgress();
            })
            .catch((ex) => {
                logError(ex);
                if (this.$label !== undefined) this.$label.html(ex !== undefined ? ex : "Fehler beim Laden.");
            });

        return this;
    }

    public load(): Promise<void> {
        this.updateProgress();
        this.done = Promise.all(this.loadHandlers).then(() => {
            this.finish();
        });

        return this.done;
    }

    private updateProgress() {
        const percent = (100 / this.loadHandlers.length) * this.currentProgressed;
        this.$fill.css("height", percent + "%");
    }

    private finish() {
        this.$fill
            .css("height", "100%")
            .delay(400)
            .queue((e) => {
                this.$element.fadeOut("easeOutExpo", () => {
                    this.$element.remove();
                });

                e();
            });
    }
}
